module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9d8c83dee048441a6b4da2d330e646ca.png";